<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.copyLinkHeader}}</h3>
</div>
<div class="modal-body">
    <span>{{LOCALIZATION.copyLinkMessage}}</span>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	<button class="btn btn-primary" type="button" (click)="copyToClipboard()">{{LOCALIZATION.copyLink}}</button>
</div>
